//animate block
;(function($){    
    let $items = $(".js-animate");

    if (!$items.length) return;

    let animateClass = browserType.ieVersion ? "is-animate_ie" : "is-animate";
    let windowHeight = $(window).innerHeight();
    
    $items.css("visibility", "hidden");

    $(window).resize(() => {
        windowHeight = $(window).innerHeight();
    });

    checkItemPos();

    $(window).scroll(checkItemPos);

    function checkItemPos() {
        $items.each((i, el) => {
            let elTop = $(el).offset().top;

            if ($(window).scrollTop() + windowHeight > elTop) {
                $(el).css("visibility", "visible")
                    .addClass(animateClass);
            }
        });
    }
})(jQuery);


// WEBPACK FOOTER //
// ./common.blocks/animate/animate.js